import PathLink from './PathLink.js';
import $ from 'jquery';
class FloorChangeNode { 
  constructor(name, service) {
    this.name = name;
    this.x = service.pinLocation.x;
    this.y = service.pinLocation.y;
    this.floorIndex = service.floorIndex;
    this.serviceType = service.serviceType;
    this.type = 'FloorChangeNode';
    this.links = [];
    this.IsInCl;
    this.BestDist;
    this.BestLink;
  }
  connectTo(node2, new_Cost = -1){
    var newlink = new PathLink(this, node2, new_Cost);
    if($.isEmptyObject(newlink)){
      newlink = null;
    }else{
      this.links.push(newlink);
      node2.links.push(newlink);
    }
    return newlink;
  }
}
export default FloorChangeNode;